<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1280px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.payerName"
              placeholder="请输入付款方名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="tableList.tableQuery.search.unitName"
              placeholder="请输入收款方名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="tableList.tableQuery.search.searchStartDate"
              type="date"
              placeholder="选择付款开始日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="tableList.tableQuery.search.searchEndDate"
              type="date"
              placeholder="选择付款结束日期"
              style="width:100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @selectItem="selectItemFun(arguments)"
          @dblclick="selectItemFun(arguments)"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadPaymentVoucherListDataApi } from '@/api/paymentVoucher'

export default {
  name: 'PaymentVoucherTodoCheckList',
  components: { CustomTable },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'payment_voucher_todo_red_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'selectItem',
            label: '选择该付款单',
            method: 'selectItem'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            payerName: '',
            unitName: '',
            searchStartDate: '',
            searchEndDate: '',
            status: 2,
            billType: 1
          }
        }
      },
      isPaging: true,
      payMethodOptions: [{ value: 1, label: '对公转账' }, { value: 3, label: '个人垫付' }],
      payChannelOptions: [{ value: 1, label: '网银' }, { value: 2, label: '微信' }, { value: 3, label: '支付宝' }, { value: 4, label: '现金' }],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '复核' }],
      id: null, // 选中的单据ID
      eventType: '',
      dialogCheckTitle: '',
      dialogCheckVisible: false,
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.tableList.initTableColumn = [
            { prop: 'rowNumber', label: '序号', width: 80 },
            { prop: 'provinceName', label: '省区', filterColumn: 'pv.province_name', width: 90 },
            { prop: 'cityName', label: '城市', filterColumn: 'pv.city_name', width: 100 },
            { prop: 'payerName', label: '付款方', filterColumn: 'pv.payer_name', width: 150 },
            { prop: 'projectNames', label: '支付项目', filterColumn: 'pv.project_names', width: 200 },
            { prop: 'payMethodValue', label: '付款方式', filterColumn: 'pv.pay_method', filterValue: 'payMethod', filterArray: this.payMethodOptions, width: 105 },
            { prop: 'payChannelValue', label: '支付渠道', filterColumn: 'pv.pay_channel', filterValue: 'payChannel', filterArray: this.payChannelOptions, width: 105 },
            { prop: 'payBankName', label: '付款银行', filterColumn: 'pv.pay_bank_name', width: 150 },
            { prop: 'payBankNo', label: '付款账号', filterColumn: 'pv.pay_bank_no', width: 140 },
            { prop: 'unitName', label: '收款单位', filterColumn: 'u.unit_name', width: 150 },
            { prop: 'unitBankName', label: '收款银行', filterColumn: 'pv.unit_bank_name', width: 150 },
            { prop: 'unitBankNo', label: '收款账号', filterColumn: 'pv.unit_bank_no', width: 140 },
            { prop: 'payDateValue', label: '付款日期', filterColumn: 'pv.pay_date', width: 110, isBetween: true },
            { prop: 'payAmount', label: '付款金额', filterColumn: 'pv.pay_amount', width: 110, formatPrice: true },
            { prop: 'statusValue', label: '状态', filterColumn: 'pv.status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
            { prop: 'remark', label: '备注', filterColumn: 'pv.remark', width: 180 },
            { prop: 'creator', filterColumn: 'pv.creator', label: '制单人', width: 100 },
            { prop: 'createTimeValue', filterColumn: 'pv.create_time', label: '制单时间', width: 150, isBetween: true },
            { prop: 'checker', filterColumn: 'pv.checker', label: '复核人', width: 100 },
            { prop: 'checkTimeValue', filterColumn: 'pv.check_time', label: '复核时间', width: 150, isBetween: true }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.tableList.tableQuery.sort.order = ''
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      loadPaymentVoucherListDataApi({ condition: JSON.stringify(this.tableList.tableQuery) }).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data || []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 选择付款单
    selectItemFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的付款单', type: 'warning' })
        return
      }
      this.$emit('selectedPaymentVoucherFun', args[0])
      this.modalClose()
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
